/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePagedList } from '../../models/charge-paged-list';
import { ChargeSearchBody } from '../../models/charge-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchStationCharges$Json$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * START_DATE : the start date
 *   * END_DATE : the start date
 */
  sortFieldName?: 'START_DATE' | 'END_DATE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search charge
     */
    body?: ChargeSearchBody
}

export function searchStationCharges$Json(http: HttpClient, rootUrl: string, params: SearchStationCharges$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchStationCharges$Json.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargePagedList>;
    })
  );
}

searchStationCharges$Json.PATH = '/stations/{uid}/charges/search';
